{
  "achievementCenter": "Achievement Center",
  "achievementCenterSubtitle": "Unlock badges, earn XP, grow your level and build your Exalt Exchange identity.",
  "badges": "Badges",
  "bearish": "Bearish",
  "bullish": "Bullish",
  "buy": "Buy",
  "comment": "Comment",
  "commentAddedSuccessfully": "Comment added successfully.",
  "commentFailed": "Failed to add comment.",
  "communityFeed": "Community Feed",
  "communityPosts": "Community Posts",
  "completedTrades": "Completed Trades",
  "copyCode": "Copy Code",
  "copyLink": "Copy Link",
  "createSignalPost": "Create Signal / Market Post",
  "currentLevel": "Current Level",
  "displayName": "Display Name",
  "disputes": "Disputes",
  "exaltTrader": "EXALT Trader",
  "failedCreatePost": "Failed to create post.",
  "failedLoadAchievements": "Failed to load achievements.",
  "failedLoadReputation": "Failed to load reputation.",
  "failedLoadSocialTrading": "Failed to load Social Trading.",
  "failedRefreshAchievements": "Failed to refresh achievements.",
  "failedRefreshReputation": "Failed to refresh reputation.",
  "follow": "Follow",
  "followFailed": "Failed to update follow status.",
  "followers": "Followers",
  "following": "Following",
  "fraudFlags": "Fraud Flags",
  "goldBadges": "Gold Badges",
  "joinExaltUsingReferral": "Join Exalt Exchange using my referral code and start trading.",
  "joined": "Joined",
  "levelProgress": "Level Progress",
  "levelProgressText": "Keep earning XP to reach the next level.",
  "like": "Like",
  "likeFailed": "Failed to update like.",
  "loading": "Loading...",
  "loadingAchievementCenter": "Loading Achievement Center...",
  "loadingQr": "Loading QR code...",
  "loadingReputationCenter": "Loading Reputation Center...",
  "loadingSocialTrading": "Loading Social Trading...",
  "locked": "Locked",
  "low": "Low",
  "myTraderProfile": "My Trader Profile",
  "neutral": "Neutral",
  "noAchievementProfileFound": "No achievement profile found.",
  "noBadgesYet": "No badges yet.",
  "noPostsYet": "No posts yet.",
  "noReferralRewardsYet": "No referral rewards yet.",
  "noReferredMembersYet": "You haven't referred anyone yet.",
  "noReputationHistoryYet": "No reputation history yet.",
  "noReputationProfileFound": "No reputation profile found.",
  "noTraders": "No traders found.",
  "noTradersFound": "No traders found.",
  "p2pOrders": "P2P Orders",
  "p2pRating": "P2P Rating",
  "pair": "Pair",
  "platinum": "Platinum",
  "postCreatedSuccessfully": "Post created successfully.",
  "posting": "Posting...",
  "previous": "Previous",
  "profitLoss": "Profit / Loss",
  "publishPost": "Publish Post",
  "referralCodeCopied": "Referral code copied.",
  "referralLinkCopied": "Referral link copied.",
  "referralLoadFailed": "Failed to load referral data.",
  "referralQrCode": "Referral QR Code",
  "referralReward": "Referral Reward",
  "referralRewardHistory": "Referral Reward History",
  "referredUser": "Referred User",
  "refreshAchievements": "Refresh Achievements",
  "refreshScore": "Refresh Score",
  "reputationCenter": "Community Reputation",
  "reputationCenterSubtitle": "Build your EXALT identity with trading trust, P2P success, verified badges and community activity.",
  "reputationHistory": "Reputation History",
  "reputationScore": "Reputation Score",
  "searchYourMembers": "Search your members by name or email",
  "sell": "Sell",
  "send": "Send",
  "sentiment": "Sentiment",
  "serverError": "Server error.",
  "sessionExpired": "Session expired. Please login again.",
  "shareMarketViewPlaceholder": "Share a market view, trading setup, EXALT update or signal...",
  "shareReferralLink": "Share Referral Link",
  "signal": "Signal",
  "socialTradingSubtitle": "Follow expert traders, share market ideas, view signals and grow with the EXALT trading community.",
  "socialTradingTitle": "Social Trading",
  "topTraders": "Top Traders",
  "topTradersLeaderboard": "Top Traders Leaderboard",
  "totalComments": "Total Comments",
  "totalEarnings": "Total Earnings",
  "totalLikes": "Total Likes",
  "totalReferrals": "Total Referrals",
  "totalTraders": "Total Traders",
  "totalXp": "Total XP",
  "tradeType": "Trade Type",
  "tradingSuccess": "Trading Success",
  "unfollow": "Unfollow",
  "unlocked": "Unlocked",
  "username": "Username",
  "verified": "Verified",
  "winRate": "Win Rate",
  "writeBeforePosting": "Please write something before posting.",
  "writeComment": "Write a comment...",
  "yourReferralCode": "Your Referral Code",
  "yourReferralLink": "Your Referral Link",
  "yourReferredMembers": "Your Referred Members"
}